import { memo, useState, useEffect, useId } from "react";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Styles from './dishcard.module.scss'
import InfoModal from "../InfoModal";
import { baseRecipeCodeArray } from "../../../constants";
import { DIET_CODE_CLASSES } from "../../../constants";
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';


interface CardProps {
  id?: number;
  title?: string;
  quantityType?: string;
  qty?: number;
  price?: number;
  unit?: string;
  baseRecipe?: string;
  onDelete?: (id: number) => void;
  dietcode?: string;
  typecode?: string;
  colorcode?: string;
  alias?: string | null;
  weightperpc?: number,
  priceandunit?: string,
  ismenurequistion?: boolean,
  IsItems?: any,
  portionuomcode?: any,
  isexmenureq?: any
  costcolor?: string;
  isEMR?: boolean;
  disableRequisition?: boolean;
  // CPU/Onsite toggle props
  iscpumappedrequisition?: string | boolean | null;
  iscpuplanned?: boolean;
  isonsiteplanned?: boolean;
  onToggleChange?: (newValue: boolean) => void;
  dishname?: string;
  portionsize?: number | string;
}

const EditableCard: React.FC<CardProps> = ({
  title,
  dietcode,
  alias,
  typecode,
  colorcode,
  weightperpc,
  priceandunit,
  IsItems,
  portionuomcode,
  isexmenureq,
  costcolor,
  isEMR,
  disableRequisition,
  iscpumappedrequisition,
  iscpuplanned,
  isonsiteplanned,
  dishname,
  portionsize,
  onToggleChange,
}) => {
  const [infoModal, setInfoModal] = useState({
    show: false,
    heading: '',
    message: ''
  })
  
  const showcostValue = localStorage.getItem('showcost');
  const ishybrid = useSelector((state: RootState) => state.menuRequisition.ishybrid);
  const dietCodeClassName = dietcode ? DIET_CODE_CLASSES[dietcode] || "" : "";
  
  // CPU/Onsite toggle logic similar to EditableCard
  const normalizeFlag = (value: any): boolean => {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    if (value === 1 || value === '1') return true;
    if (value === 0 || value === '0') return false;
    return !!value;
  };

  const cpuPlanned = normalizeFlag(iscpuplanned);
  const onsitePlanned = normalizeFlag(isonsiteplanned);

  // Compute toggle thumb color based on planning conditions
  const computeToggleColor = () => {
    if (cpuPlanned && onsitePlanned) {
      return '#4caf50';
    }
    return '#A7A9AA';
  };

  // Compute initial toggle state based on conditions
  const computeToggleState = () => {
    let cpuMappedRequisition: boolean | null = null;
    if (iscpumappedrequisition !== null && iscpumappedrequisition !== undefined) {
      cpuMappedRequisition = normalizeFlag(iscpumappedrequisition);
    }

    // Simplified logic as per user requirements:
    // 1. If iscpumappedrequisition is false -> OnSite
    if (cpuMappedRequisition === false) {
      return true; // OnSite selected
    }
    
    // 2. If iscpumappedrequisition is null/undefined AND both planned -> OnSite by default
    if ((cpuMappedRequisition === null) && cpuPlanned && onsitePlanned) {
      return true; // OnSite selected
    }
    
    // 3. Otherwise -> CPU
    return false; // CPU selected by default
  };

  const computeToggleDisabled = () => {
    if (disableRequisition) return true;
    
    if (cpuPlanned && onsitePlanned) {
      return false; // Enable toggle
    }
    
    return true; // Disable toggle
  };

  const [cpuOn, setCpuOn] = useState<boolean>(computeToggleState());

  // Unique ID per component instance — prevents radio name collisions across cards
  const componentId = useId();

  // Update toggle state when props change (this was missing!)
  useEffect(() => {
    const newToggleState = computeToggleState();
    setCpuOn(newToggleState);
  }, [iscpumappedrequisition, iscpuplanned, isonsiteplanned]);

  // Handle toggle change
  const handleToggleChange = (newValue: boolean) => {
    setCpuOn(newValue);
    if (onToggleChange) {
      onToggleChange(newValue);
    }
  };
  return (
    <div className="dish-card-wrapper">
      <div className={Styles.dishCard}>
        <div className={Styles.cardTitle}>
          <div className={`flex titlePrice ${Styles.titlePrice}`}>  
            <span className={dietCodeClassName} />
            <div className={`colorCode ${Styles.colorCode}`} style={{ backgroundColor: colorcode,border: `0.5px solid gray` }}></div>
           
            {title && !IsItems && (
              <div className={`flex ${Styles.titleVlaue}`}>
                <strong className="discardTitle">{`${dishname} - ${portionsize}`}
                  {weightperpc === 0 && ' gms'}
                  {weightperpc !== 0 ? (
                    <b style={{ fontWeight: 'normal' }}> <b style={{ fontWeight: 'bold' }}>Pcs</b>{`(@${weightperpc} gms each)`}</b>
                  ) : null}
                </strong>
              </div>
            )}
            {IsItems &&
              <div className={`flex ${Styles.titleVlaue}`}>                
                <strong className="flex discardTitle">{title} {portionuomcode && `(${portionuomcode}) `}{showcostValue === 'true' && isexmenureq && '|'} {showcostValue === 'true' && isexmenureq && <em className={`flex justify-content-between align-items-center light-grey-bg${Styles.priceValue}`}>
                  &#8377;                 
                   <b style={{ color: costcolor, marginRight: '0' }}>{priceandunit?.split('/')[0] || '0'}</b>/{priceandunit?.split('/')[1] || 'Kg'}
                  </em>}
                </strong>
              </div>
            }
          </div>
          {/* {IsItems && baseRecipeCodeArray.includes(typecode || '') && (
            <span className={`${Styles.baseTitle} ${Styles.baseTitleInline}`}>Base</span>
          )} */}
          {baseRecipeCodeArray.includes(typecode || '') && (
            <span className={`${Styles.baseTitle} ${Styles.baseTitleInline}`}>Base</span>
          )}
          {/* For IsItems cards, show Dish Alias in the row below */}
        </div>

        {!isEMR && iscpuplanned !== undefined && isonsiteplanned !== undefined && (
          !ishybrid ? false : (
          <div className={`flex justify-content-start ${Styles.radioRow}`}>
            <div className="projectionRadioGroup">
              {onsitePlanned && (
                <div className="projectionRadioSlot right">
                  <label className="projectionRadioLabel">
                    <input
                      type="radio"
                      name={`dish-mode-${componentId}`}
                      checked={cpuOn === true}
                      disabled={computeToggleDisabled()}
                      onChange={() => handleToggleChange(true)}
                    />
                     <span style={{ color: computeToggleDisabled() ? '#9b9b9b' : '#DF8B66' }}>Get From Site</span>
                  </label>
                </div>
              )}
              {cpuPlanned && (
                <div className="projectionRadioSlot right">
                  <label className="projectionRadioLabel">
                    <input
                      type="radio"
                      name={`dish-mode-${componentId}`}
                      checked={cpuOn === false}
                      disabled={computeToggleDisabled()}
                      onChange={() => handleToggleChange(false)}
                    />
                    <span style={{ color: computeToggleDisabled() ? '#9b9b9b' : '#7A7A7A' }}>Get From CPU</span>
                  </label>
                </div>
              )}
            </div>
          </div>
          )
        )}
      </div>

      {infoModal && (
        <InfoModal
          open={infoModal.show}
          handleClose={() => { setInfoModal({ show: false, heading: '', message: '' }) }}
          title={infoModal.heading}
          description={infoModal.message}
          closeText="Close"
          singleBtn={true}
        />
      )}
    </div>
  );
};

export default memo(EditableCard);
